export default [
  {
    header: 'Cosecha',
    resource: 'Trabajador Nuevo Re',
    action: 'menu',
  },
  {
    title: 'Mantenedor',
    icon: 'ServerIcon',
    children: [
      {
        title: 'Grupo Labor',
        icon: 'BoxIcon',
        resource: 'Grupo Re',
        children: [
          {
            title: 'Grupo',
            route: 'grupore',
            action: 'menu',
            resource: 'Grupo Re'
          },
          {
            title: 'Actividad',
            route: 'actividadre',
            action: 'menu',
            resource: 'Actividad Re'
          },
          {
            title: 'Labor',
            route: 'laborre',
            action: 'menu',
            resource: 'Labor Re'
          },
        ]
      },
      {
        title: 'Categorización',
        icon: 'BoxIcon',
        resource: 'Categoria Re',
        children: [
          {
            title: 'Categoría',
            route: 'categoriare',
            action: 'menu',
            resource: 'Categoria Re'
          },
          {
            title: 'Plantilla Categoría',
            route: 'plantillacategoriare',
            action: 'menu',
            resource: 'Plantilla Categoria Re'
          },
          {
            title: 'Criterio Categoría',
            route: 'criteriocategoriare',
            action: 'menu',
            resource: 'Criterio Categoria Re'
          },
        ]
      },

      {
        title: 'Otros',
        icon: 'BoxIcon',
        resource: 'Cos Parametro Re',
        children: [

          {
            title: 'Parámetro',
            route: 'cosparametrore',
            action: 'menu',
            resource: 'Cos Parametro Re'
          },
          {
            title: 'Día No laborable',
            route: 'cosdiaferiadore',
            action: 'menu',
            resource: 'Cos diaFeriado Re'
          },
          {
            title: 'Día Canjeado',
            route: 'cosdiacanjeadore',
            action: 'menu',
            resource: 'Cos Dia Canjeado Re'
          },

        ]
      },

    ],
  },
  {
    title: 'Baja productividad',
    icon: 'fa-solid fa-person',
    children: [
      {
        title: 'Trabajador',
        route: 'trabajadornuevore',
        action: 'menu',
        resource: 'Trabajador Nuevo Re'
      },
      {
        title: 'Ratio cosecha',
        route: 'ratiocosechare',
        action: 'menu',
        resource: 'Ratio Cosecha Re'
      },
      {
        title: 'Resumen ratio',
        route: 'resumenratiore',
        action: 'menu',
        resource: 'Resumen Ratio Re'
      },
      {
        title: 'Trabajador excluido',
        route: 'trabajadorexcluido',
        action: 'menu',
        resource: 'Dar Baja Trabajador Re'
      },
      {
        title: 'Dar Baja Trabajador',
        route: 'darbajatrabajadorre',
        action: 'menu',
        resource: 'Dar Baja Trabajador Re'
      },
        /*
      {
        title: 'KPI Semanal',
        route: 'rendimientosemanare',
        action: 'menu',
        resource: 'Rendimiento Semanal Re'
      },*/
      {
        title: 'Obs. Área Cosecha',
        route: 'listanegrare',
        action: 'menu',
        resource: 'Lista Negra Re'
      },

      {
        title: 'Obs. Área RR.HH',
        route: 'vistanewre',
        action: 'menu',
        resource: 'Vista New Re'
      },
      {
        title: 'Reingreso L. Negra',
        route: 'cosechaobservadore',
        action: 'menu',
        resource: 'Cosecha Observado Re'
      },
      /*
      {
        title: 'Filtros',
        route: 'vistanewdosres',
        action: 'menu',
        resource: 'Vista New Dos Res'
      },*/

    ],
  },
  {
    title: 'Historial',
    icon: 'fa-solid fa-clock-rotate-left',
    children: [
      {
        title: 'Cosechadores',
        route: 'historial_cosechadores',
        action: 'menu',
        resource: 'Historial Cosechadores'
      },
      {
        title: 'Días Experiencia',
        route: 'historialdiaexperiencia',
        action: 'menu',
        resource: 'Historial Dia Experiencia'
      },
    ],
  },


  // {
  //   title:'Historial Cosechadores',
  //   icon:'fa-solid fa-clock-rotate-left',
  //   children:[
  //     {
  //       title: 'Gráfico 01',
  //       route: '',
  //       action: 'menu',
  //       resource: ''
  //     },
  //   ]
  // }



]
